import Vue from 'vue'
import Router from 'vue-router'
import axios from './axios'
import Dashboard from './views/Dashboard.vue'
import store from './store'
import LeadsView from "@/views/LeadsView";
import OrdersView from "@/views/OrdersView";
import CalculatorView from "@/views/CalculatorView.vue";
import RenewalsView from "@/views/RenewalsView.vue";
Vue.use(Router)

const router = new Router({
  mode: 'history',
  // hash: false,

  base: process.env.BASE_URL,
  linkExactActiveClass: 'linkActiveClass',
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        title: 'Dashboard',
      }
    },
    {
      path: '/personalDashboard',
      name: 'personalDashboard',
      component: () => import('./views/PersonalDashboard.vue'),
      meta: {
        title: 'Personal Dashboard',
      }
    },
    {
      path: '/mySettings',
      name: 'mySettings',
      component: () => import('./views/UserSettings.vue'),
      meta: {
        title: 'My Settings',
      }
    },

    {
      path: '/orders',
      name: 'orders',
      component: () => import('./views/TableController.vue'),
      meta: {
        title: 'Orders',
      }
    },

    // {
    //   path: '/neworders',
    //   name: 'neworders',
    //   component: OrdersView,
    //   meta: {
    //     title: 'Orders',
    //   }
    // },
    // {
    //   path: '/leads',
    //   name: 'leads',
    //   component: () => import('./views/TableController.vue'),
    //   meta: {
    //     title: 'Leads',
    //   }
    // },
    {
      path: '/leads',
      name: 'leads',
      component: LeadsView,
      meta: {
        title: 'Leads',
      }
    },
    {
      path: '/calculator',
      name: 'calculator',
      component: CalculatorView,
      meta: {
        title: 'Calculator',
      }
    },
    {
      path: '/ordersControl',
      name: 'ordersControl',
      component: () => import('./views/TableController.vue'),
      meta: {
        title: 'ordersControl',
      }
    },
    {
      path: '/ordersProtect',
      name: 'ordersProtect',
      component: () => import('./views/TableController.vue'),
      meta: {
        title: 'ordersProtect',
      }
    },
    {
      path: '/ordersCancellations',
      name: 'ordersCancellations',
      component: () => import('./views/TableController.vue'),
      meta: {
        title: 'ordersCancellations',
      }
    },
    {
      path: '/ordersCollection',
      name: 'ordersCollection',
      component: () => import('./views/TableController.vue'),
      meta: {
        title: 'ordersCollection',
      }
    },
    {
      path: '/ordersTasks',
      name: 'ordersTasks',
      component: () => import('./views/TableController.vue'),
      meta: {
        title: 'ordersTasks',
      }
    },
    {
      path: '/ordersClaims',
      name: 'ordersClaims',
      component: () => import('./views/TableController.vue'),
      meta: {
        title: 'ordersClaims',
      }
    },
    {
      path: '/clients',
      name: 'clients',
      component: () => import('./views/TableController.vue'),
      meta: {
        title: 'Clients',

      }
    },
    {
      path: '/renewals',
      name: 'renewals',
      component: RenewalsView,
      meta: {
        title: 'Renewals',
      }
    },

    {
      path: '/policies',
      name: 'policies',
      component: () => import('./views/TableController.vue'),
      meta: {
        title: 'Policies',
      }
    },

    {
      path: '/tasks',
      name: 'tasks',
      component: () => import('./views/TableController.vue'),
      meta: {
        title: 'Tasks',
      }
    },

    {
      path: '/departments',
      name: 'departments',
      component: () => import('./views/TableController.vue'),
      meta: {
        title: 'Departments',
        secure: true
      }
    },

    {
      path: '/statuses',
      name: 'statuses',
      component: () => import('./views/TableController.vue'),
      meta: {
        title: 'Statuses',
        secure: true
      }
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('./views/TableController.vue'),
      meta: {
        title: 'Users',
        secure: true
      }
    },

    {
      path: '/messages',
      name: 'messages',
      component: () => import('./views/TableController.vue'),
      meta: {
        title: 'Messages',
        secure: true
      }
    },
    {
      path: '/whatsappCampaign',
      name: 'whatsappCampaign',
      //component: WhatsAppMessagesView,
      component: () => import('./views/TableController.vue'),
      meta: {
        title: 'Whatsapp Campaign',
        secure: true
      }
    },
    {
      path: '/smsCampaign',
      name: 'smsCampaign',
      //component: WhatsAppMessagesView,
      component: () => import('./views/TableController.vue'),
      meta: {
        title: 'Sms Campaign',
        secure: true
      }
    },
    {
      path: '/mailCampaign',
      name: 'mailCampaign',
      //component: WhatsAppMessagesView,
      component: () => import('./views/TableController.vue'),
      meta: {
        title: 'Mail Campaign',
        secure: true
      }
    },
    {
      path: '/phoneBook',
      name: 'phoneBook',
      component: () => import('./views/TableController.vue'),
      meta: {
        title: 'Phone book',
        secure: true
      }
    },
    {
      path: '/view',
      name: 'view',
      component: () => import('./views/ViewOne.vue'),
      meta: {
        title: 'View: ',
      }
    },
    {
      path: '/pelecard_callback',
      name: 'pelecard_callback',
      component: () => import('./components/pelecard_callback.vue'),
      meta: {
        title: 'pelecard: ',
      }
    }
    /*{
      path: '/print',
      name: 'Print',
      component: () => import('./views/Print.vue'),

    },*/
  ]
})

router.beforeEach(async (to, from, next) => {
  // Agency no-login order link (client request): exchange agency_token for a
  // real session (same response shape otpAuth returns -- see Login.vue) before
  // the normal auth guard below runs. Silently falls through on failure
  // (invalid/expired link, unauthorized IP) -- same as any unauthenticated visit.
  if (to.query.agency_token && !store.state.user.token) {
    try {
      const res = await axios.post('agencyOrderAccess', {
        orderId: to.query.id,
        token: to.query.agency_token
      })
      axios.defaults.headers.Authorization = 'Bearer ' + res.data.data.token
      // isAgencyLink flags this session so the toolbar/view can hide
      // logout/new-order/go-back/drafts/related-orders for it (client request).
      // agencyOrderId is kept so axios.js can send the agent back to their own
      // order if they try to view a different one (backend-enforced too).
      store.dispatch('login', { ...res.data.data, isAgencyLink: true, agencyOrderId: to.query.id })

      // Token is one-time-use from here on (client request) -- drop it from the
      // URL so it isn't left sitting in the address bar/history/bookmarks. `id`
      // stays: ViewOne.vue reads $route.query.id throughout, not just on mount.
      //
      // Resolved via this guard's own next() (not a separate router.replace())
      // -- firing an un-awaited router.replace() here while this same guard is
      // still mid-resolution raced it against the pending navigation below,
      // sometimes mounting the destination component before its data fetch was
      // ready (needed a manual refresh to show the credit-card buttons).
      const cleanedQuery = { ...to.query }
      delete cleanedQuery.agency_token
      next({ path: to.path, query: cleanedQuery, replace: true })
      return
    } catch (e) {
      // continue as a normal (unauthenticated) visit
    }
  }

  // https://stackoverflow.com/questions/7307983/while-variable-is-not-defined-wait
  if (!store.state.user.type) {
    while (!store.state.user.type) {
      await new Promise(resolve => setTimeout(resolve, 500)).then(() => {
        if (to.meta.secure) {
          if (store.getters.isAdmin) {
            next()
          } else {
            return
          }
        }
        next()

      })
    }
  } else {
    if (to.meta.secure) {
      if (store.getters.isAdmin) {
        next()
      } else {
        return
      }
    }
    next()
  }

})

function isAdmin() {
  if (store.state.user.type) {
    return store.getters.isAdmin
  } else {
    console.log('ion')
    setTimeout(isAdmin, 500)
  }
}

// function isAdmin () {
//   if (store.state.user.type) {
//     return store.getters.isAdmin
//   } else {
//     console.log('in')
//     setTimeout(isAdmin(), 1000)
//   }
// }

const DEFAULT_TITLE = 'Hova - CRM | '
router.afterEach((to, from) => {

  let meta = ''
  switch (to.name) {
    case 'view':
      meta = to.query.table + ' ' + to.query.id + ' ' + to.query.name
      break
    default:
      meta = ''
  }
  document.title = DEFAULT_TITLE + to.meta.title + meta
})

export default router
